export const CELL_KEY_DOWNLOAD = 'download';
export const CELL_KEY_PREVIEW = 'preview';
export const ANALYTICS_MEDIA_CHANNEL = 'media';